module.exports = __webpack_public_path__ + "img/sweden-blood-diseases-male.ca3c5ea8.png";